<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form
        class="ant-advanced-search-form"
        layout="inline"
        :form="form"
        @submit="searchQuery"
      >
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item label="客户名称">
              <a-input
                placeholder="请输入客户名称"
                v-decorator="['realName']"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="客户类型">
              <a-select placeholder="请选择客户类型" v-decorator="['custType']">
                <a-select-option value="0">机构</a-select-option>
                <a-select-option value="1">个人</a-select-option>
                <a-select-option value="2">
                  产品
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="expand">
            <a-col :md="6" :sm="8">
              <a-form-item label="手机号">
                <a-input
                  placeholder="请输入手机号"
                  v-decorator="['mobile']"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="产品名称">
                <a-input
                  placeholder="请输入产品名称"
                  v-decorator="['fundName']"
                ></a-input>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item label="产品代码">
                <a-input
                  placeholder="请输入产品代码"
                  v-decorator="['fundCode']"
                ></a-input>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="8">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
              <a @click="toggle" style="margin-left: 8px">
                {{ expand ? '收起' : '展开' }}
                <a-icon :type="expand ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    <a-table
      ref="table"
      size="middle"
      :scroll="{ x: true }"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      @change="handleTableChange"
    >
    </a-table>
  </a-card>
</template>

<script>
import { jsonAction } from '@/api/manage';
export default {
  name: 'followProduct',
  data() {
    return {
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 }
        }
      },
      form: this.$form.createForm(this),
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      columns: [
        {
          title: '客户名称',
          align: 'center',
          sorter: true,
          dataIndex: 'realName'
        },
        {
          title: '客户类型',
          align: 'center',
          dataIndex: 'custType',
          customRender: function(text) {
            if (text == 1) {
              return '个人';
            } else if (text == 0) {
              return '机构';
            } else if (text == 2) {
              return '产品';
            } else {
              return;
            }
          }
        },
        {
          title: '手机号',
          align: 'center',
          dataIndex: 'mobile'
        },
        {
          title: '产品名称',
          align: 'center',
          dataIndex: 'fundName'
        },
        {
          title: '产品代码',
          align: 'center',
          dataIndex: 'fundCode'
        }
      ],
      loading: false,
      expand: false, //展开收起
      url: {
        list: process.env.VUE_APP_CMS_PRODUCT + '/product/fund/collect/list'
      }
    };
  },
  mounted() {
    this.initList();
  },

  methods: {
    initList() {
      this.form.validateFields((error, values) => {
        let params = {
          ...values,
          pageSize: this.ipagination.pageSize,
          pageNo: this.ipagination.current
        };
        this.loading = true;
        jsonAction(this.url.list, params, 'POST').then(res => {
          this.loading = false;
          if (res.success) {
            this.dataSource =
              res.result && res.result.records ? res.result.records : [];
            this.ipagination.total = res.result.total;
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    searchQuery() {
      this.initList();
    },
    //重置
    searchReset() {
      this.form.resetFields();
      this.initList();
    },
    toggle() {
      this.expand = !this.expand;
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.ipagination = pagination;
      this.initList();
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
